import { useTranslation } from "react-i18next";
import { IoClose } from "react-icons/io5";
import "./ScanGuidance.scss";
import { BalanceLightIcon } from "../../icons/BalanceLightIcon";
import { NoGlassesIcon } from "../../icons/NoGlassesIcon";
import { NoMakeUpIcon } from "../../icons/NoMakeUpIcon";
import { HairDownIcon } from "../../icons/HairDownIcon";
import { useConfig } from "../../../context/ConfigContext";
import Button from "../../Button/Button";

export const ScanGuidance = ({ onContinue, onExitClick }) => {
  const { t } = useTranslation("scanGuidancePage");
  const { configData } = useConfig();
  const iconMap = {
    balancedLighting: {
      icon: BalanceLightIcon,
      text: t("bad-light"),
    },
    noGlasses: {
      icon: NoGlassesIcon,
      text: t("no-glasses"),
    },
    noMakeup: {
      icon: NoMakeUpIcon,
      text: t("no-make-up"),
    },
    hairDown: {
      icon: HairDownIcon,
      text: t("hair-down"),
    },
  };
  const showCustomIcons = configData?.ScanGuidancePageFlags?.isEnabled;
  const selectedIcons = configData?.ScanGuidancePageFlags?.selectedIcons || [];

  return (
    <div className="scan-guidance-overlay">
      <div className="scan-guidance-close-wrapper">
        <IoClose
          className="overlay-close-icon"
          onClick={() => onExitClick?.()}
        />
      </div>
      <div
        className={
          "scan-guidance-content" +
          ((showCustomIcons ? selectedIcons.length : 3) === 4
            ? " four-icons"
            : "")
        }
      >
        {(showCustomIcons
          ? selectedIcons
          : ["balancedLighting", "noGlasses", "noMakeup"]
        ).map((key) => {
          const entry = iconMap[key];
          if (!entry) return null;
          const Icon = entry.icon;
          return (
            <div className="scan-guidance-item" key={key}>
              <Icon className="scan-guidance-icon" />
              <span className="scan-guidance-text">{entry.text}</span>
            </div>
          );
        })}
      </div>
      <div className="take-photo-button-wrapper">
        <Button text={t("take-photo")} onClick={onContinue} />
      </div>
    </div>
  );
};
